import { FocusEvent, KeyboardEvent } from 'react';
import { IMaskInput } from 'react-imask';
import { TIME_DOUBLE_PATTERN, TIME_DOUBLE_REG_EXP } from '@common/constants/regex';
import { Notify, TableRecord } from '@common/types';
import { IILSCellTimeProps } from '@common/types/components/table/cell';
import { ILSUserNotify } from '@common/components';
import { doubleToTime } from '@common/utils';

export const ILSCellTimeMasked = <R extends TableRecord>({ children, toggleEdit, save }: IILSCellTimeProps<R>): JSX.Element => {
  const [node, time] = children;

  const defaultValue = doubleToTime(Number(time || 0));

  const handleBlur = (e: FocusEvent<HTMLInputElement> | KeyboardEvent<HTMLInputElement>) => {
    try {
      if (e.target instanceof Element) {
        const { value } = e.target;
        if (!value) {
          save(null);
        }

        if (TIME_DOUBLE_REG_EXP.test(value)) {
          save(value);
        } else {
          ILSUserNotify(Notify.Warning, 'Введите корректное время', 5);
        }
      }
      return;
    } catch (error) {
      ILSUserNotify(Notify.Error, `Ошибка: ${error}`);
    } finally {
      toggleEdit?.();
    }
  };

  return (
    <>
      {node}
      <IMaskInput
        mask={TIME_DOUBLE_PATTERN}
        value={defaultValue}
        unmask={true}
        className={'input ant-input cell-wrapper-editable-full'}
        placeholder="00:00"
        // @ts-ignore
        onBlur={handleBlur}
      />
    </>
  );
};

